/* eslint no-tabs: "off", indent: "off" */
import _ from "underscore";

import { adjustStartDateForAggregation } from "lib/helpers/graphHelpers.js";
import { updateDataCompare, updateLowerDataCompare, updateDataByDateCompare, updateGraphDataCompare } from "actions/dataCompare.js";
import { RESET_ARTICLES_CURSOR_POS } from "actions/constants.js";

// Set Legend Height
export function setGraphHeightRight(height) {
	return (dispatch, getState) => {
		const leftHeight = getState().leftCompare.graphHeight;
		dispatch({
			type: "setGraphHeightCompare",
			commonHeight: Math.round((leftHeight > height ? leftHeight : height) * 0.1) * 10,
			rightHeight: height,
		});
	};
}

// Set graph grid height
export function updateGraphSizeRight(graphSize) {
	return (dispatch, getState) => {
		const { height } = graphSize;
		const leftHeight = getState().leftCompare.graphGridHeight;
		dispatch({
			type: "setGraphSizeCompare",
			tallestHeight: leftHeight > height ? leftHeight : height,
			rightHeight: height,
		});
	};
}
export function setCompareHeaderHeightRight(height) {
	return (dispatch, getState) => {
		const leftHeight = getState().leftCompare.headerHeight;
		dispatch({
			type: "setCompareHeaderHeight",
			commonHeight: leftHeight > height ? leftHeight : height,
			rightHeight: height,
		});
	};
}

export function setSideWidthRight(width) {
	return {
		type: "setSideWidthRight",
		width,
	};
}

export function togglePerspectiveRight() {
	return (dispatch, getState) => {
		const { activeKeywords, activeNarrativeData, perspective } = getState().rightCompare;
		const { location } = getState().router;
		const { varStore } = getState().storage;

		const eventMode = location && location.pathname === "/events";
		const newPerspective = perspective === "Source" ? "Audience" : "Source";
		const filtersList = varStore.right[newPerspective].filters;

		dispatch(
			updateDataCompare({
				side: "Right",
				narrative: activeNarrativeData,
				perspective: newPerspective,
				currentZoom: varStore.right[perspective].currentZoom,
				activeFilters: filtersList,
				entityFilters: newPerspective === "Source" ? varStore.right.Source.entityFilters : [],
				keywords: activeKeywords,
				mapHighlightId: varStore.right[perspective].mapHighlightId,
				contentFilteredByDate: varStore.right[perspective].contentFilteredByDate,
				eventMode,
			})
		);
		dispatch({ type: "togglePerspectiveRight", perspective: newPerspective, filtersList });
	};
}

export const graphScaleChangeRight = (scale) => {
	return {
		type: "graphScaleChangeRight",
		scale,
	};
};

export const toggleEntityFiltersDrawerRight = () => {
	return (dispatch, getState) => {
		if (getState().rightCompare.entityFiltersOpen) {
			dispatch({ type: "closeEntityFiltersRight" });
		} else {
			dispatch({ type: "openEntityFiltersRight" });
		}
	};
};

// Filter conent by date (on graph click)
export function filterContentByDateRight(unit, left) {
	return (dispatch, getState) => {

		const { location } = getState().router;
		const { varStore } = getState().storage;
		const { 
			activeKeywords,
			activeNarrativeData,
			aggregationLevel,
			perspective
		} = getState().rightCompare;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const narType = moeMode ? "rightMOE" : eventMode ? "rightEvent" : "right";

		const adjustedBegin = adjustStartDateForAggregation({ 
			startDate: Number(unit), 
			aggregationLevel,
		});
		const adjustedEnd = Number(unit) + (24 * 60 * 60 * 1000) - 1;

		const contentFilteredByDate = unit
			? {
					begin: adjustedBegin,
					end: adjustedEnd,
					indicatorWidth: 3,
					indicatorOffset: left,
				}
			: false;

		dispatch({ type: "filterContentByDateRight", contentFilteredByDate });
		// dispatch({
		// 	type: "graphScaleChangeRight",
		// 	scale: "this is not a scale",
		// });
		dispatch({ type: `${RESET_ARTICLES_CURSOR_POS}_Right` });
		dispatch(
			updateDataByDateCompare({
				narrative: activeNarrativeData,
				perspective,
				currentZoom: varStore[narType][perspective].currentZoom,
				activeFilters: varStore[narType][perspective].filters,
				entityFilters: varStore[narType][perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore[narType][perspective].mapHighlightId,
				contentFilteredByDate,
				narType,
				side: "Right",
				offset: 0,
			})
		);
	};
}
// For updating contentFilteredByDate after window/graph resize
export const formatContentFilteredByDateRight = (graphSize, trimmedTrendDates) => {
	return {
		type: "formatContentFilteredByDateRight",
		graphSize,
		trimmedTrendDates,
	};
};

// clears filterContentByDate indicator
export function clearIndicatorRight() {
	return (dispatch, getState) => {
		const { activeKeywords, activeNarrativeData, perspective } = getState().rightCompare;
		const { varStore } = getState().storage;
		const { location } = getState().router;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const narType = moeMode ? "rightMOE" : eventMode ? "rightEvent" : "right";

		dispatch({ type: `${RESET_ARTICLES_CURSOR_POS}_Right` });
		dispatch(
			updateDataByDateCompare({
				narrative: activeNarrativeData,
				perspective,
				currentZoom: varStore[narType][perspective].currentZoom,
				activeFilters: varStore[narType][perspective].filters,
				entityFilters: varStore[narType][perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore[narType][perspective].mapHighlightId,
				contentFilteredByDate: false,
				narType,
				side: "Right",
				offset: 0,
			})
		);
		dispatch({ type: "clearIndicatorRight" });
	};
}

export const zoomCompleteRight = (zoom) => {
	return {
		type: "setCurrentZoomRight",
		currentZoom: zoom,
	};
};
export const zoomInitRight = (zoom) => {
	return (dispatch, getState) => {
		const { activeKeywords, activeNarrativeData, perspective } = getState().rightCompare;
		const { varStore } = getState().storage;
		const { location } = getState().router;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const narType = moeMode ? "rightMOE" : eventMode ? "rightEvent" : "right";
		const thePerspective = eventMode ? "Source" : perspective;

		dispatch({ type: `${RESET_ARTICLES_CURSOR_POS}_Right` });
		dispatch(
			updateLowerDataCompare({
				narrative: activeNarrativeData,
				perspective: thePerspective,
				currentZoom: zoom,
				activeFilters: varStore[narType][thePerspective].filters,
				entityFilters: varStore[narType][thePerspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore[narType][thePerspective].mapHighlightId,
				contentFilteredByDate: false,
				narType,
				side: "Right",
				offset: 0,
			})
		);
	};
};

export const dataTypeSelectRight = (dataType) => {
	return (dispatch) => {
		dispatch(updateGraphDataCompare({ dataType, side: "Right" }));
	};
};

// Tooltips
export function closeNarrativeTooltipRight() {
	return {
		type: "closeNarrativeTooltipRight",
	};
}
export function openNarrativeTooltipRight(position, nar) {
	return {
		type: "openNarrativeTooltipRight",
		position,
		nar,
	};
}

// Header dropdown
export function toggleNarrativeSelectRight(id, isOpen) {
	return {
		type: isOpen ? "closeNarrativeSelectRight" : "openNarrativeSelectRight",
	};
}
export function closeNarrativeSelectRight() {
	return {
		type: "closeNarrativeSelectRight",
	};
}
export function setNarrativeSelectRight(narrative) {
	return (dispatch, getState) => {
		dispatch({
			type: "setNarrativeSelectRight",
			eventFilters: getState().events.eventFilters,
			narrative,
			compareMultiSelect: getState().projectConfig.compareMultiSelect,
		});
	};
}

export function toggleNarrativeFiltersRight(id, isOpen) {
	return {
		type: isOpen ? "closeNarrativeFiltersRight" : "openNarrativeFiltersRight",
	};
}
export function closeNarrativeFiltersRight() {
	return {
		type: "closeNarrativeFiltersRight",
	};
}
export function setNarrativeFiltersRight(params) {
	return {
		type: "setNarrativeFiltersRight",
		params,
	};
}
